<template>
  <router-view />
  <AppSnackbar />
</template>

<script>
import AppSnackbar from '@/components/AppSnackbar.vue';

export default {
  name: 'App',

  components: {
    AppSnackbar
  }
};
</script>

<style>
html {
  overflow-y: auto !important;
}

html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

/* Marks a required form field consistently app-wide: a red asterisk
   after the label, independent of the field's error/validation state. */
.required-field .v-field-label::after {
  content: ' *';
  color: rgb(var(--v-theme-error));
}
</style>
